import { Component, OnInit } from '@angular/core';
import { LoggingService } from '@EfsServices/logging.service';
import { GuardLinkService } from '@EfsServices/guard-link.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from '@EfsServices/data-sharing.service';
import { environment } from '@efsEnvironments/environment';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
    selector: 'app-national-setup-page',
    templateUrl: './national-setup-page.component.html',
    styleUrls: ['./national-setup-page.component.css'],
    standalone: false
})

export class NationalSetupPageComponent implements OnInit {
  

  lockDown = false;
  bannerMessage = 'Maintenance in progress, no changes will be saved for the next 4';

  browser;
  ieMessage = false;
  lockdownMsg = false;

  constructor(
    private loggingService: LoggingService,
    private guardLinkService: GuardLinkService,
    private router: Router,
    public route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    public permissionHandlingService: PermissionHandlingService,
  ) { }

  ngOnInit() {
    this.loggingService.logInfo('landed on National Setup page');
    sessionStorage.setItem('clientId', 'null');
    sessionStorage.setItem('clientNm', 'null');
    sessionStorage.setItem('fromCorp', 'null');
    sessionStorage.setItem('toCorp', 'null');
    sessionStorage.setItem('planType', 'null');

    this.setPermissions();

    // check for browser, dont use ie for now
    this.browser = navigator.userAgent;
    console.log('browser is ' + this.browser);
    if (navigator.userAgent.indexOf('rv:11.0') !== -1) {
      console.log('ie detected!');
      this.ieMessage = true;
      this.lockdownMsg = false;
      this.lockDown = true;
    } else {
      console.log('not detected!');
    }
  }

  logNavigation(link) {
    this.loggingService.logInfo('pressed ' + link + ' link');
  }

  navigateTo(moduleName) { // validate the link and navigate. add any new modules here
    console.log('In NavigateTo Method');
    this.guardLinkService.validateLink().subscribe(() => {
      if (moduleName === 'national corp setup') {
        this.router.navigate(['nationalSetup/nationalCorpSetup']);
        this.dataSharingService.shareData('moduleNCS');
      }
      if (moduleName === 'national package template') {
        this.router.navigate(['nationalSetup/nationalPackageTemplate']);
        this.dataSharingService.shareData('moduleNPA');
      }
      if (moduleName === 'national dispatch template') {
        this.router.navigate(['nationalSetup/nationalDispatchTemplate']);
        this.dataSharingService.shareData('moduleNDI');
      }
  });
  }

  setPermissions() {
    // TODO define the session storage name once they exist;
    // TEMPORARY ALLOW USER ACCESS TO DELAYED MAIL AND PRODUCTION SETUP IF THEY HAVE PREHOLD ACCESS,
    // REMOVE ACCESS AND REPLACE WITH RESPECTIVE ROLES ONCE THEY EXIST

    /* Release of modules are on a schedule, Environment will restrict access to individual modules.
       DEV and QA will have access to all modules at all times, UAT will have release ready modules only
    */
    // including uat for testing all template modules
    if (environment.envName === 'dev' || environment.envName === 'QA' || environment.envName === 'INT' || environment.envName === 'UAT') {
      // national corp setup
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP READ') === true) {
        this.permissionHandlingService.ncsRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP WRITE') === true) {
        this.permissionHandlingService.ncsWrite = true;
      }

      // national package template
      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === true) {
        this.permissionHandlingService.npaRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE WRITE') === true) {
        this.permissionHandlingService.npaWrite = true;
      }

      // national dispatch template (use same as corp setup)
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP READ') === true) {
        this.permissionHandlingService.ndiRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP WRITE') === true) {
        this.permissionHandlingService.ndiWrite = true;
      }
    } else if (environment.envName === 'PROD' || environment.envName === 'UAT') {
      // UAT and PROD are high environments, will only have release modules here
      // special instructions
      // national corp setup
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP READ') === true) {
        this.permissionHandlingService.ncsRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP WRITE') === true) {
        this.permissionHandlingService.ncsWrite = true;
      }

      // national package template
      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === true) {
        this.permissionHandlingService.npaRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE WRITE') === true) {
        this.permissionHandlingService.npaWrite = true;
      }

      // national dispatch template (use same as corp setup)
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP READ') === true) {
        this.permissionHandlingService.ndiRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP WRITE') === true) {
        this.permissionHandlingService.ndiWrite = true;
      }
    }
  }
}
